import React, { useState } from "react";
import { TriangleAlert } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { storageService } from "../service/storage";

function FormChangePassProcess() {
  const {setStepOneForgotPassword,stepOneChangePass} = useAuth();
  const [formData, setFormData] = useState({
    email: "",
    codigoFarmacia: ""
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [shake, setShake] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Limpiar error al escribir
    if (error) setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validación básica
    if (!formData.email || !formData.codigoFarmacia) {
      triggerShake();
      setError("Por favor completa todos los campos");
      return;
    }

    // Validación de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      triggerShake();
      setError("Por favor ingresa un correo electrónico válido");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const responsePetition = await stepOneChangePass(formData);
      const response = responsePetition.data;
      
      // Comprobaciones del response
      if (!response) {
        throw new Error("No se recibió respuesta del servidor");
      }

      // Verificar que existe sessionId
      if (!response.sessionId) {
        throw new Error("No se recibió el identificador de sesión");
      }
      storageService.setSession(response.sessionId);
      // Verificar que sessionId es string y tiene longitud válida (24 chars en tu ejemplo)
      if (typeof response.sessionId !== "string") {
        throw new Error("El identificador de sesión no tiene formato válido");
      }

      if (response.sessionId.length < 10) {
        throw new Error("El identificador de sesión es inválido");
      }

      // Si todo está correcto, llamar al callback de éxito
      setStepOneForgotPassword(true);
    } catch (err) {
      setStepOneForgotPassword(false);
      setError(err.message || "Ocurrió un error al procesar tu solicitud");
      triggerShake();
    } finally {
      setIsLoading(false);
    }
  };

  const triggerShake = () => {
    setShake(true);
    setTimeout(() => setShake(false), 500);
  };

  return (
    <>
      <div className="logo-wrapper-login">
        <div className="logo-container">
          <img
            src="/img/base_logo.png"
            alt="Tu Farmacia en el Bolsillo"
            className="app-logo"
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
        </div>

        <div className="logo-fallback" style={{ display: "none" }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z" />
            <path d="M12 8v8M8 12h8" strokeLinecap="round" />
          </svg>
        </div>
      </div>

      <div className="brand-header">
        <h1>Recuperar <span className="highlight">Contraseña</span></h1>
        <p className="subtitle">Ingresa tus datos para iniciar el proceso</p>
      </div>

      {/* Mensaje de error */}
      {error && (
        <div className="error-message">
          <TriangleAlert size={26} />
          {error}
        </div>
      )}

      <form 
        className={`login-form ${shake ? 'shake-animation' : ''}`} 
        onSubmit={handleSubmit}
      >
        <div className="input-field">
          <label htmlFor="email">Correo Electrónico</label>
          <input
            id="email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Ingresa tu correo electrónico"
            autoComplete="email"
          />
        </div>

        <div className="input-field">
          <label htmlFor="codigoFarmacia">Código de Farmacia</label>
          <input
            id="codigoFarmacia"
            type="text"
            name="codigoFarmacia"
            value={formData.codigoFarmacia}
            onChange={handleChange}
            placeholder="Ingresa el código de tu farmacia"
            autoComplete="off"
          />
        </div>

        <button
          type="submit"
          className={`submit-btn ${isLoading ? "loading" : ""}`}
          disabled={isLoading || !formData.email || !formData.codigoFarmacia}
        >
          {isLoading ? <span className="loader" /> : "Continuar"}
        </button>
      </form>
    </>
  );
}

export default FormChangePassProcess;